// extracted by mini-css-extract-plugin
module.exports = {"ModalButton":"appointments__ArrangeAppointment__ModalButton"};